// global
import React, { isValidElement, useState } from 'react';
import PropTypes from 'prop-types';
// stylesheet
import styles from './DefaultButton.module.scss';
// consts
import { COLORS } from 'app/config/colors';

function DefaultButton(props) {
  const {
    // children,
    isActive,
    tag,
    size,
    icon,
    iconHover,
    iconDisabled,
    value,
    onClick,
    disabled,
    color,
    colorHover,
    borderColor,
    backgroundColor,
    borderColorHover,
    backgroundColorHover,
    fullWidth,
    disableOnClick,
    ...rest
  } = props;

  const [isHover, setIsHover] = useState(false);
  const [disabledByClick, setDisabledByClick] = useState(false);

  const isThereTag = tag !== '';

  const styleNoTag = `${styles[size]} ${styles.noTag}`;
  const styleWithTag = `${styles[size]} ${styles.tag}`;

  const handleClassName = () => {
    let className = isThereTag ? styleWithTag : styleNoTag;

    if (fullWidth) className += ` ${styles.fullWidth}`;

    return className;
  };

  const style = {
    '--color': isActive ? colorHover : color,
    '--backgroundColor': isActive ? backgroundColorHover : backgroundColor,
    '--borderColor': borderColor,
    '--colorHover': colorHover,
    '--borderColorHover': borderColorHover,
    '--backgroundColorHover': backgroundColorHover
  };

  const src = {
    '--icon': isActive ? `url(${iconHover})` : `url(${icon})`,
    '--iconHover': `url(${iconHover})`,
    '--iconDisabled': iconDisabled ? `url(${iconDisabled})` : `url(${icon})`
  };

  const showIcon = icon || iconHover;

  const handleIcon = icon => {
    if (isValidElement(icon)) {
      return isHover && iconHover ? iconHover : icon;
    } else {
      return <img style={src} className={styles.icon} alt='view button' />;
    }
  };

  const handleClick = (...rest) => {
    if (disableOnClick) setDisabledByClick(true);

    onClick(...rest);
  };

  return (
    <button
      type='button'
      value={value}
      onClick={handleClick}
      disabled={disabled || disabledByClick}
      className={handleClassName()}
      style={style}
      {...rest}
      onMouseOver={() => setIsHover(true)}
      onMouseOut={() => setIsHover(false)}
    >
      {showIcon ? handleIcon(icon) : null}
      {tag}
    </button>
  );
}

DefaultButton.defaultProps = {
  tag: '',
  isActive: false,
  size: 'small',
  disabled: false,
  color: COLORS.WHITE_VARIANT,
  borderColor: COLORS.ACCENTUATED_VARIANT,
  backgroundColor: COLORS.ACCENTUATED_VARIANT,
  colorHover: COLORS.ACCENTUATED_VARIANT,
  borderColorHover: COLORS.ACCENTUATED_VARIANT,
  backgroundColorHover: COLORS.WHITE_VARIANT,
  fullWidth: false,
  disableOnClick: false,
  onClick: () => {}
};

DefaultButton.propTypes = {
  isActive: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  iconHover: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  iconDisabled: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'big', 'huge']),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.oneOf(Object.values(COLORS)),
  borderColor: PropTypes.oneOf(Object.values(COLORS)),
  backgroundColor: PropTypes.oneOf(Object.values(COLORS)),
  colorHover: PropTypes.oneOf(Object.values(COLORS)),
  borderColorHover: PropTypes.oneOf(Object.values(COLORS)),
  backgroundColorHover: PropTypes.oneOf(Object.values(COLORS)),
  fullWidth: PropTypes.bool,
  disableOnClick: PropTypes.bool
};

export default DefaultButton;
